import {
  AddCircleOutline,
  Close,
  Search,
  SearchOutlined,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { errorCallback } from "../../../libs/firebase/errorCallback";
import { getAllData } from "../../../libs/firebase/firestore/getAllData";
import { successCallback } from "../../../libs/firebase/successCallback";
import EventListItem from "./ListItem";

function eventToLabel(event) {
  let types = event.type;
  let label = "";
  // for each type
  types.forEach((type, index) => {
    // if not the last type
    let typeLabel = type.toLowerCase();
    if (index === 0) {
      // capitalize first letter
      typeLabel = typeLabel.charAt(0).toUpperCase() + typeLabel.slice(1);
    }
    if (index < types.length - 2) {
      label += typeLabel + "d, ";
    } else if (index < types.length - 1) {
      label += typeLabel + "d and ";
    } else {
      label += typeLabel + "d";
    }
  });
  //   label += " " + event.name.toLowerCase();

  event.label = label;
}

function eventsToLabels(events) {
  events.map((event) => eventToLabel(event));
}

const EventList = ({ onClose, open = false, siteUid }) => {
  const [events, setEvents] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  // const [, setSelectedPlant] = useState(null);
  const searchRef = useRef(null);

  useEffect(() => {
    if (isSearching && searchRef.current) {
      searchRef.current.focus();
    }
    // get events from firebase
    getAllData(
      `/sites/${siteUid}/events`,
      (events) => {
        console.log(events);
        setEvents(events);
        successCallback();
      },
      errorCallback
    );
  }, [isSearching]);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleSearchClose = () => {
    setIsSearching(false);
    setSearchValue("");
  };

  const handleSearchClick = () => {
    setIsSearching(true);
  };

  eventsToLabels(events);

  const filteredEvents = events.filter((event) => {
    let eventName = event.name.toLowerCase();
    let eventLabel = event.label.toLowerCase();

    // split search on spaces
    // if any word matches, return true
    let thingsToSearchFor = searchValue.toLowerCase().split(" ");

    let found = false;
    thingsToSearchFor.forEach((thing) => {
      if (eventName.includes(thing) || eventLabel.includes(thing)) {
        found = true;
      } else {
        found = false;
      }
    });

    return found;
  });

  const sortedEvents = filteredEvents.sort((a, b) => {
    if (a.name < b.name) return -1;
    return 1;
  });

  // const groupedPlants = groupPlants(sortedPlants);

  return (
    <Slide direction="up" in={open}>
      <Box
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: "75%",
          backgroundColor: "#fff",
          zIndex: 1300,
          overflowX: "auto",
          padding: "16px",
          display: "flex",
          // alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Stack direction={"row"}>
          <Typography variant="h5" style={{ marginBottom: "16px" }}>
            Events
          </Typography>
          <div style={{ flexGrow: 1 }}></div>
          {isSearching ? (
            <IconButton onClick={handleSearchClose}>
              <Close />
            </IconButton>
          ) : (
            <>
              <IconButton onClick={handleSearchClick}>
                <SearchOutlined />
              </IconButton>
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </>
          )}
        </Stack>

        {isSearching ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: 2,
              backgroundColor: "#f2f2f2",
              padding: "2px 4px",
              marginBottom: "16px",
            }}
          >
            <IconButton sx={{ p: "10px" }} aria-label="search">
              <Search />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search for a plant"
              value={searchValue}
              onChange={handleSearchChange}
              inputRef={searchRef}
            />
          </Box>
        ) : null}

        <List>
          {sortedEvents.map((event, index) => (
            <EventListItem key={index} label={event.label} event={event} />
          ))}
        </List>
      </Box>
    </Slide>
  );
};

export default EventList;
